import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import useDownloadShipmentLabel
  from "@beeldit/ecommerce/orders/actions/download-shipment-label/useDownloadShipmentLabel";
import {Order} from "@beeldit/ecommerce/orders/models/Order";

function useDownloadShipmentLabelAction(): any {

  const onSuccess= () => {
    showSuccessMessage("successfull_action");
  };

  const downloadShipmentLabel = useDownloadShipmentLabel();

  const downloadShipmentLabelFunction = (order: Order) => downloadShipmentLabel(order, onSuccess);

  return {
    downloadShipmentLabelFunction,
  };
}

export default useDownloadShipmentLabelAction;
